/* tslint:disable */
/* eslint-disable */
/**
 * Real Estate CRM Web API
 * API endpoints for web application
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { CreateProjectPlanCommand } from '../models';
// @ts-ignore
import { ProjectPlanBriefDto } from '../models';
// @ts-ignore
import { ProjectPlanDto } from '../models';
// @ts-ignore
import { ProjectPlanDtoPaginatedList } from '../models';
// @ts-ignore
import { ProjectPlanStatus } from '../models';
// @ts-ignore
import { UpdateProjectPlanCommand } from '../models';
// @ts-ignore
import { UpdateProjectPlanStatusCommand } from '../models';
/**
 * ProjectPlansApi - axios parameter creator
 * @export
 */
export const ProjectPlansApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} projectId 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [searchTerm] 
         * @param {ProjectPlanStatus} [status] 
         * @param {boolean} [isOverdue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectsProjectIdPlansGet: async (projectId: number, pageNumber?: number, pageSize?: number, searchTerm?: string, status?: ProjectPlanStatus, isOverdue?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('apiProjectsProjectIdPlansGet', 'projectId', projectId)
            const localVarPath = `/api/projects/{projectId}/plans`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (isOverdue !== undefined) {
                localVarQueryParameter['isOverdue'] = isOverdue;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} projectId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectsProjectIdPlansIdDelete: async (projectId: number, id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('apiProjectsProjectIdPlansIdDelete', 'projectId', projectId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiProjectsProjectIdPlansIdDelete', 'id', id)
            const localVarPath = `/api/projects/{projectId}/plans/{id}`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} projectId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectsProjectIdPlansIdGet: async (projectId: number, id: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('apiProjectsProjectIdPlansIdGet', 'projectId', projectId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiProjectsProjectIdPlansIdGet', 'id', id)
            const localVarPath = `/api/projects/{projectId}/plans/{id}`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} projectId 
         * @param {number} id 
         * @param {UpdateProjectPlanCommand} [updateProjectPlanCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectsProjectIdPlansIdPut: async (projectId: number, id: number, updateProjectPlanCommand?: UpdateProjectPlanCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('apiProjectsProjectIdPlansIdPut', 'projectId', projectId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiProjectsProjectIdPlansIdPut', 'id', id)
            const localVarPath = `/api/projects/{projectId}/plans/{id}`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProjectPlanCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} projectId 
         * @param {number} id 
         * @param {UpdateProjectPlanStatusCommand} [updateProjectPlanStatusCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectsProjectIdPlansIdStatusPut: async (projectId: number, id: number, updateProjectPlanStatusCommand?: UpdateProjectPlanStatusCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('apiProjectsProjectIdPlansIdStatusPut', 'projectId', projectId)
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiProjectsProjectIdPlansIdStatusPut', 'id', id)
            const localVarPath = `/api/projects/{projectId}/plans/{id}/status`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProjectPlanStatusCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} projectId 
         * @param {boolean} [overdueOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectsProjectIdPlansPendingGet: async (projectId: number, overdueOnly?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('apiProjectsProjectIdPlansPendingGet', 'projectId', projectId)
            const localVarPath = `/api/projects/{projectId}/plans/pending`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (overdueOnly !== undefined) {
                localVarQueryParameter['overdueOnly'] = overdueOnly;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} projectId 
         * @param {CreateProjectPlanCommand} [createProjectPlanCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectsProjectIdPlansPost: async (projectId: number, createProjectPlanCommand?: CreateProjectPlanCommand, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('apiProjectsProjectIdPlansPost', 'projectId', projectId)
            const localVarPath = `/api/projects/{projectId}/plans`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createProjectPlanCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProjectPlansApi - functional programming interface
 * @export
 */
export const ProjectPlansApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProjectPlansApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} projectId 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [searchTerm] 
         * @param {ProjectPlanStatus} [status] 
         * @param {boolean} [isOverdue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProjectsProjectIdPlansGet(projectId: number, pageNumber?: number, pageSize?: number, searchTerm?: string, status?: ProjectPlanStatus, isOverdue?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectPlanDtoPaginatedList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProjectsProjectIdPlansGet(projectId, pageNumber, pageSize, searchTerm, status, isOverdue, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} projectId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProjectsProjectIdPlansIdDelete(projectId: number, id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProjectsProjectIdPlansIdDelete(projectId, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} projectId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProjectsProjectIdPlansIdGet(projectId: number, id: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProjectPlanDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProjectsProjectIdPlansIdGet(projectId, id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} projectId 
         * @param {number} id 
         * @param {UpdateProjectPlanCommand} [updateProjectPlanCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProjectsProjectIdPlansIdPut(projectId: number, id: number, updateProjectPlanCommand?: UpdateProjectPlanCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProjectsProjectIdPlansIdPut(projectId, id, updateProjectPlanCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} projectId 
         * @param {number} id 
         * @param {UpdateProjectPlanStatusCommand} [updateProjectPlanStatusCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProjectsProjectIdPlansIdStatusPut(projectId: number, id: number, updateProjectPlanStatusCommand?: UpdateProjectPlanStatusCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProjectsProjectIdPlansIdStatusPut(projectId, id, updateProjectPlanStatusCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} projectId 
         * @param {boolean} [overdueOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProjectsProjectIdPlansPendingGet(projectId: number, overdueOnly?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProjectPlanBriefDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProjectsProjectIdPlansPendingGet(projectId, overdueOnly, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} projectId 
         * @param {CreateProjectPlanCommand} [createProjectPlanCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProjectsProjectIdPlansPost(projectId: number, createProjectPlanCommand?: CreateProjectPlanCommand, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProjectsProjectIdPlansPost(projectId, createProjectPlanCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProjectPlansApi - factory interface
 * @export
 */
export const ProjectPlansApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProjectPlansApiFp(configuration)
    return {
        /**
         * 
         * @param {number} projectId 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [searchTerm] 
         * @param {ProjectPlanStatus} [status] 
         * @param {boolean} [isOverdue] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectsProjectIdPlansGet(projectId: number, pageNumber?: number, pageSize?: number, searchTerm?: string, status?: ProjectPlanStatus, isOverdue?: boolean, options?: any): AxiosPromise<ProjectPlanDtoPaginatedList> {
            return localVarFp.apiProjectsProjectIdPlansGet(projectId, pageNumber, pageSize, searchTerm, status, isOverdue, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} projectId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectsProjectIdPlansIdDelete(projectId: number, id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiProjectsProjectIdPlansIdDelete(projectId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} projectId 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectsProjectIdPlansIdGet(projectId: number, id: number, options?: any): AxiosPromise<ProjectPlanDto> {
            return localVarFp.apiProjectsProjectIdPlansIdGet(projectId, id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} projectId 
         * @param {number} id 
         * @param {UpdateProjectPlanCommand} [updateProjectPlanCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectsProjectIdPlansIdPut(projectId: number, id: number, updateProjectPlanCommand?: UpdateProjectPlanCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiProjectsProjectIdPlansIdPut(projectId, id, updateProjectPlanCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} projectId 
         * @param {number} id 
         * @param {UpdateProjectPlanStatusCommand} [updateProjectPlanStatusCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectsProjectIdPlansIdStatusPut(projectId: number, id: number, updateProjectPlanStatusCommand?: UpdateProjectPlanStatusCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiProjectsProjectIdPlansIdStatusPut(projectId, id, updateProjectPlanStatusCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} projectId 
         * @param {boolean} [overdueOnly] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectsProjectIdPlansPendingGet(projectId: number, overdueOnly?: boolean, options?: any): AxiosPromise<Array<ProjectPlanBriefDto>> {
            return localVarFp.apiProjectsProjectIdPlansPendingGet(projectId, overdueOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} projectId 
         * @param {CreateProjectPlanCommand} [createProjectPlanCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProjectsProjectIdPlansPost(projectId: number, createProjectPlanCommand?: CreateProjectPlanCommand, options?: any): AxiosPromise<number> {
            return localVarFp.apiProjectsProjectIdPlansPost(projectId, createProjectPlanCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiProjectsProjectIdPlansGet operation in ProjectPlansApi.
 * @export
 * @interface ProjectPlansApiApiProjectsProjectIdPlansGetRequest
 */
export interface ProjectPlansApiApiProjectsProjectIdPlansGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ProjectPlansApiApiProjectsProjectIdPlansGet
     */
    readonly projectId: number

    /**
     * 
     * @type {number}
     * @memberof ProjectPlansApiApiProjectsProjectIdPlansGet
     */
    readonly pageNumber?: number

    /**
     * 
     * @type {number}
     * @memberof ProjectPlansApiApiProjectsProjectIdPlansGet
     */
    readonly pageSize?: number

    /**
     * 
     * @type {string}
     * @memberof ProjectPlansApiApiProjectsProjectIdPlansGet
     */
    readonly searchTerm?: string

    /**
     * 
     * @type {ProjectPlanStatus}
     * @memberof ProjectPlansApiApiProjectsProjectIdPlansGet
     */
    readonly status?: ProjectPlanStatus

    /**
     * 
     * @type {boolean}
     * @memberof ProjectPlansApiApiProjectsProjectIdPlansGet
     */
    readonly isOverdue?: boolean
}

/**
 * Request parameters for apiProjectsProjectIdPlansIdDelete operation in ProjectPlansApi.
 * @export
 * @interface ProjectPlansApiApiProjectsProjectIdPlansIdDeleteRequest
 */
export interface ProjectPlansApiApiProjectsProjectIdPlansIdDeleteRequest {
    /**
     * 
     * @type {number}
     * @memberof ProjectPlansApiApiProjectsProjectIdPlansIdDelete
     */
    readonly projectId: number

    /**
     * 
     * @type {number}
     * @memberof ProjectPlansApiApiProjectsProjectIdPlansIdDelete
     */
    readonly id: number
}

/**
 * Request parameters for apiProjectsProjectIdPlansIdGet operation in ProjectPlansApi.
 * @export
 * @interface ProjectPlansApiApiProjectsProjectIdPlansIdGetRequest
 */
export interface ProjectPlansApiApiProjectsProjectIdPlansIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ProjectPlansApiApiProjectsProjectIdPlansIdGet
     */
    readonly projectId: number

    /**
     * 
     * @type {number}
     * @memberof ProjectPlansApiApiProjectsProjectIdPlansIdGet
     */
    readonly id: number
}

/**
 * Request parameters for apiProjectsProjectIdPlansIdPut operation in ProjectPlansApi.
 * @export
 * @interface ProjectPlansApiApiProjectsProjectIdPlansIdPutRequest
 */
export interface ProjectPlansApiApiProjectsProjectIdPlansIdPutRequest {
    /**
     * 
     * @type {number}
     * @memberof ProjectPlansApiApiProjectsProjectIdPlansIdPut
     */
    readonly projectId: number

    /**
     * 
     * @type {number}
     * @memberof ProjectPlansApiApiProjectsProjectIdPlansIdPut
     */
    readonly id: number

    /**
     * 
     * @type {UpdateProjectPlanCommand}
     * @memberof ProjectPlansApiApiProjectsProjectIdPlansIdPut
     */
    readonly updateProjectPlanCommand?: UpdateProjectPlanCommand
}

/**
 * Request parameters for apiProjectsProjectIdPlansIdStatusPut operation in ProjectPlansApi.
 * @export
 * @interface ProjectPlansApiApiProjectsProjectIdPlansIdStatusPutRequest
 */
export interface ProjectPlansApiApiProjectsProjectIdPlansIdStatusPutRequest {
    /**
     * 
     * @type {number}
     * @memberof ProjectPlansApiApiProjectsProjectIdPlansIdStatusPut
     */
    readonly projectId: number

    /**
     * 
     * @type {number}
     * @memberof ProjectPlansApiApiProjectsProjectIdPlansIdStatusPut
     */
    readonly id: number

    /**
     * 
     * @type {UpdateProjectPlanStatusCommand}
     * @memberof ProjectPlansApiApiProjectsProjectIdPlansIdStatusPut
     */
    readonly updateProjectPlanStatusCommand?: UpdateProjectPlanStatusCommand
}

/**
 * Request parameters for apiProjectsProjectIdPlansPendingGet operation in ProjectPlansApi.
 * @export
 * @interface ProjectPlansApiApiProjectsProjectIdPlansPendingGetRequest
 */
export interface ProjectPlansApiApiProjectsProjectIdPlansPendingGetRequest {
    /**
     * 
     * @type {number}
     * @memberof ProjectPlansApiApiProjectsProjectIdPlansPendingGet
     */
    readonly projectId: number

    /**
     * 
     * @type {boolean}
     * @memberof ProjectPlansApiApiProjectsProjectIdPlansPendingGet
     */
    readonly overdueOnly?: boolean
}

/**
 * Request parameters for apiProjectsProjectIdPlansPost operation in ProjectPlansApi.
 * @export
 * @interface ProjectPlansApiApiProjectsProjectIdPlansPostRequest
 */
export interface ProjectPlansApiApiProjectsProjectIdPlansPostRequest {
    /**
     * 
     * @type {number}
     * @memberof ProjectPlansApiApiProjectsProjectIdPlansPost
     */
    readonly projectId: number

    /**
     * 
     * @type {CreateProjectPlanCommand}
     * @memberof ProjectPlansApiApiProjectsProjectIdPlansPost
     */
    readonly createProjectPlanCommand?: CreateProjectPlanCommand
}

/**
 * ProjectPlansApi - object-oriented interface
 * @export
 * @class ProjectPlansApi
 * @extends {BaseAPI}
 */
export class ProjectPlansApi extends BaseAPI {
    /**
     * 
     * @param {ProjectPlansApiApiProjectsProjectIdPlansGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectPlansApi
     */
    public apiProjectsProjectIdPlansGet(requestParameters: ProjectPlansApiApiProjectsProjectIdPlansGetRequest, options?: AxiosRequestConfig) {
        return ProjectPlansApiFp(this.configuration).apiProjectsProjectIdPlansGet(requestParameters.projectId, requestParameters.pageNumber, requestParameters.pageSize, requestParameters.searchTerm, requestParameters.status, requestParameters.isOverdue, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProjectPlansApiApiProjectsProjectIdPlansIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectPlansApi
     */
    public apiProjectsProjectIdPlansIdDelete(requestParameters: ProjectPlansApiApiProjectsProjectIdPlansIdDeleteRequest, options?: AxiosRequestConfig) {
        return ProjectPlansApiFp(this.configuration).apiProjectsProjectIdPlansIdDelete(requestParameters.projectId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProjectPlansApiApiProjectsProjectIdPlansIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectPlansApi
     */
    public apiProjectsProjectIdPlansIdGet(requestParameters: ProjectPlansApiApiProjectsProjectIdPlansIdGetRequest, options?: AxiosRequestConfig) {
        return ProjectPlansApiFp(this.configuration).apiProjectsProjectIdPlansIdGet(requestParameters.projectId, requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProjectPlansApiApiProjectsProjectIdPlansIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectPlansApi
     */
    public apiProjectsProjectIdPlansIdPut(requestParameters: ProjectPlansApiApiProjectsProjectIdPlansIdPutRequest, options?: AxiosRequestConfig) {
        return ProjectPlansApiFp(this.configuration).apiProjectsProjectIdPlansIdPut(requestParameters.projectId, requestParameters.id, requestParameters.updateProjectPlanCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProjectPlansApiApiProjectsProjectIdPlansIdStatusPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectPlansApi
     */
    public apiProjectsProjectIdPlansIdStatusPut(requestParameters: ProjectPlansApiApiProjectsProjectIdPlansIdStatusPutRequest, options?: AxiosRequestConfig) {
        return ProjectPlansApiFp(this.configuration).apiProjectsProjectIdPlansIdStatusPut(requestParameters.projectId, requestParameters.id, requestParameters.updateProjectPlanStatusCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProjectPlansApiApiProjectsProjectIdPlansPendingGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectPlansApi
     */
    public apiProjectsProjectIdPlansPendingGet(requestParameters: ProjectPlansApiApiProjectsProjectIdPlansPendingGetRequest, options?: AxiosRequestConfig) {
        return ProjectPlansApiFp(this.configuration).apiProjectsProjectIdPlansPendingGet(requestParameters.projectId, requestParameters.overdueOnly, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProjectPlansApiApiProjectsProjectIdPlansPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProjectPlansApi
     */
    public apiProjectsProjectIdPlansPost(requestParameters: ProjectPlansApiApiProjectsProjectIdPlansPostRequest, options?: AxiosRequestConfig) {
        return ProjectPlansApiFp(this.configuration).apiProjectsProjectIdPlansPost(requestParameters.projectId, requestParameters.createProjectPlanCommand, options).then((request) => request(this.axios, this.basePath));
    }
}
